// Inventory of persisted embeds, September 2026, plus the privacy-preserving
// YouTube host. Only the source URL is carried over; HTML attributes are not.
const EMBED_HOSTS = new Set([
  "app.airdeck.co", "www.youtube.com", "www.youtube-nocookie.com",
  "player.vimeo.com", "www.loom.com", "open.spotify.com",
  "salesably-workspace-resources.s3.us-east-1.amazonaws.com",
]);
const MAX_SNIPPET_LENGTH = 20_000;
// Lesson plans authored as a whole HTML page (nine studio resources, the
// largest 27 KB) render as the page they are, inside a sandbox.
const MAX_DOCUMENT_LENGTH = 200_000;
const DOCUMENT_PATTERN = /^\s*(<!doctype\s+html|<html[\s>])/i;

export function getSafeEmbedUrl(value) {
  if (typeof value !== "string" || value.length > MAX_SNIPPET_LENGTH) return null;
  let source = value;
  if (value.includes("<")) {
    if (typeof document === "undefined") return null;
    // Parse in an inert template: no scripts execute or media loads, and none
    // of these nodes/attributes are inserted into the page. Only the URL leaves.
    const template = document.createElement("template");
    template.innerHTML = value;
    source = template.content.querySelector("iframe")?.getAttribute("src");
  }
  try {
    const url = new URL(source?.replace(/&amp;/g, "&"));
    if (url.protocol !== "https:" || url.username || url.password || url.port || !EMBED_HOSTS.has(url.hostname)) return null;
    return url.href;
  } catch { return null; }
}

/** What an embed renders: an allowlisted iframe `src`, or a whole HTML page
 * as `srcdoc`, which its opaque-origin sandbox keeps away from the app's
 * session, storage and document. */
export function getSafeEmbed(value) {
  if (typeof value === "string" && value.length <= MAX_DOCUMENT_LENGTH && DOCUMENT_PATTERN.test(value)) {
    return { srcdoc: value };
  }
  const src = getSafeEmbedUrl(value);
  return src ? { src } : null;
}
